/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum SystemParameterType {
  Parameter = 'Parameter',
  ContainerQuantity = 'ContainerQuantity',
  ManualTransport = 'ManualTransport',
  BobbinQuantity = 'BobbinQuantity',
  CoreLabelCopies = 'CoreLabelCopies'
}
